
    <p-dialog header="User Details" [modal]="true" [(visible)]="visible" [style]="{ width: '90w' }" (onHide)="close()">
        <div class="grid grid-cols-2 gap-4">


           <app-input-text [form]="userForm" field="username" label="Username" placeholder="Username" class="mr-4"></app-input-text>
           <app-input-text [form]="userForm" field="email" label="Email" placeholder="Email"></app-input-text>
              
            <app-input-text field="roles" label="System Role" [form]="userForm" />
          <app-input-text field="accountName" label="Account" placeholder="Account" [form]="userForm" class="mr-4"></app-input-text>
          <app-input-text field="active" label="Active" placeholder="Status" [form]="userForm"></app-input-text>      
            <div></div>
            <app-input-text field="organizationName" label="Organization" placeholder="" [form]="userForm"></app-input-text>
              <app-input-text [form]="userForm" field="organizationTitle" label="Title" placeholder="" class="mr-4"></app-input-text>
            
  </div>
        <h3>User Elections</h3>
        @if(user && user.userCampaigns) {
           <app-table [cols]="tableColumns" [items]="user.userCampaigns"></app-table> 
        }
      
    </p-dialog>